import { Component, Input } from '@angular/core';
import { PFFormatControlFigures } from '../../../../data/interfaces/circle-credit.interface';

@Component({
  selector: 'app-circle-credit-control-figures-card',
  templateUrl: './circle-credit-control-figures-card.component.html',
  styleUrls: ['./circle-credit-control-figures-card.component.scss']
})
export class CircleCreditControlFiguresCardComponent {
  @Input() data: PFFormatControlFigures | null = null;

  get hasData(): boolean {
    if (!this.data) return false;
    return !!(
      this.data.totalCurrentBalances !== undefined || 
      this.data.totalPastDueBalances !== undefined ||
      this.data.totalAccountElementsReported !== undefined
    );
  }

  get completionPercentage(): number {
    if (!this.data) return 0;
    
    const allFields = [
      'totalCurrentBalances', 'totalPastDueBalances', 'totalNameElementsReported',
      'totalAddressElementsReported', 'totalEmploymentElementsReported', 'totalAccountElementsReported'
    ];
    const filledFields = allFields.filter(field => 
      this.data![field as keyof PFFormatControlFigures] !== undefined &&
      this.data![field as keyof PFFormatControlFigures] !== null
    );
    return Math.round((filledFields.length / allFields.length) * 100);
  }

  get statusClass(): string {
    if (!this.hasData) return 'status-empty';
    const percentage = this.completionPercentage;
    if (percentage < 30) return 'status-incomplete';
    if (percentage < 70) return 'status-partial';
    return 'status-complete';
  }

  get totalDebt(): number {
    const current = this.data?.totalCurrentBalances || 0;
    const pastDue = this.data?.totalPastDueBalances || 0;
    return current + pastDue;
  }

  get debtHealthStatus(): 'good' | 'warning' | 'danger' {
    const pastDue = this.data?.totalPastDueBalances || 0;
    const total = this.totalDebt;
    
    if (total === 0) return 'good';
    
    const pastDuePercentage = (pastDue / total) * 100;
    if (pastDuePercentage === 0) return 'good';
    if (pastDuePercentage <= 30) return 'warning';
    return 'danger';
  }

  formatCurrency(amount: number | undefined): string {
    if (!amount && amount !== 0) return 'No especificado';
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN'
    }).format(amount);
  }

  getReportingCompleteness(): number {
    const fields = [
      this.data?.totalNameElementsReported || 0,
      this.data?.totalAddressElementsReported || 0,
      this.data?.totalEmploymentElementsReported || 0,
      this.data?.totalAccountElementsReported || 0
    ];
    
    const total = fields.reduce((sum, val) => sum + val, 0);
    const maxExpected = Math.max(...fields) * 4; // Asumiendo que el máximo debería ser similar en todas las categorías
    
    if (maxExpected === 0) return 0;
    return Math.round((total / maxExpected) * 100);
  }

  getCompletenessStatus(): 'excellent' | 'good' | 'fair' | 'poor' {
    const completeness = this.getReportingCompleteness();
    if (completeness >= 90) return 'excellent';
    if (completeness >= 70) return 'good';
    if (completeness >= 50) return 'fair';
    return 'poor';
  }
}
